import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";

export const findCategoryById = <T extends { id: string; children?: T[] }>(
  tree: T[],
  id: string,
): T | undefined => {
  for (const node of tree) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findCategoryById(node.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

/** 카테고리 id로 루트→leaf 경로의 label 배열 반환 */
export function findCategoryPath(
  tree: SupportCategory[],
  id: string,
): string[] {
  for (const node of tree) {
    if (node.id === id) return [node.label];
    if (node.children) {
      const sub = findCategoryPath(node.children, id);
      if (sub.length) return [node.label, ...sub];
    }
  }
  return [];
}

/** 트리에서 첫 번째 leaf 노드까지 재귀 탐색 */
export function findFirstLeaf<T extends { children?: T[] }>(node: T): T {
  if (node.children?.length) return findFirstLeaf(node.children[0]);
  return node;
}
